import axios from 'axios';
import variables from './variables';

const api = axios.create({
  baseURL: variables.API_URL,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
  withCredentials: true, // 攜帶憑證
});

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('jwtToken');
      alert('Authentication failed, please log in again!');
      window.location.replace('/');
    }
    return Promise.reject(error);
  }
);

export const get = async (url, params = {}, customHeaders = {}) => {
  try {
    const response = await api.get(url, {
      params,
      headers: {
        ...api.defaults.headers.common,
        ...customHeaders
      }
    });
    return response.data;
  } catch (error) {
    console.error('GET request error:', error);
    throw error;
  }
};

export const post = async (url, data, isMultipart = false) => {
  try {
    const headers = isMultipart ? { 'Content-Type': 'multipart/form-data' } : {};
    const response = await api.post(url, data, { headers });
    return response.data;
  } catch (error) {
    console.error('POST request error:', error);
    throw error;
  }
};

export const put = async (url, data) => {
  try {
    const response = await api.put(url, data);
    return response.data;
  } catch (error) {
    console.error('PUT request error:', error);
    throw error;
  }
};

export const del = async (url, params = {}) => {
  try {
    const response = await api.delete(url, { data: params });
    return response.data;
  } catch (error) {
    console.error('DELETE request error:', error);
    throw error;
  }
};

export default api;
